import { Pipe, PipeTransform } from '@angular/core';
import { FuseUtils } from '../fuseUtils';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform
{
    transform(mainArr: any[], searchText: string): any
    {
        return FuseUtils.filterArrayByString(mainArr, searchText);
    }
}
